// extracted by mini-css-extract-plugin
export var acitonButtons = "_bc-0";
export var additionalIcon = "_bc-f";
export var block = "_bc-1";
export var blockContent = "_bc-7";
export var blockDescription = "_bc-8";
export var blockIcon = "_bc-9";
export var blockTitle = "_bc-6";
export var border = "_bc-a";
export var center = "_bc-l";
export var edge = "_bc-b";
export var edgeLabel = "_bc-c";
export var edgePath = "_bc-d";
export var error = "_bc-e";
export var flowchart = "_bc-g";
export var flowchartContent = "_bc-h";
export var highlighted = "_bc-3";
export var hover = "_bc-4";
export var icon = "_bc-i";
export var left = "_bc-m";
export var navButton = "_bc-j";
export var navButtons = "_bc-k";
export var right = "_bc-n";
export var selected = "_bc-2";
export var small = "_bc-5";